import { Controller } from '@hotwired/stimulus';
import { hide, show } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = [
    'tenMinDemoArticles',
    'twentyMinDemoArticles',
    'tenMinDemoArticlesCta',
    'twentyMinDemoArticlesCta',
  ];
  static classes = ['isActive'];

  connect() {
    this.showTenMinDemoArticles();
  }

  showTenMinDemoArticles(event) {
    if (event) {
      event.preventDefault();
    }

    this.setCtaActive(this.tenMinDemoArticlesCtaTarget);
    this.setCtaInactive(this.twentyMinDemoArticlesCtaTarget);

    hide(this.twentyMinDemoArticlesTarget);
    show(this.tenMinDemoArticlesTarget);
  }

  showTwentyMinDemoArticles(event) {
    if (event) {
      event.preventDefault();
    }

    this.setCtaInactive(this.tenMinDemoArticlesCtaTarget);
    this.setCtaActive(this.twentyMinDemoArticlesCtaTarget);

    show(this.twentyMinDemoArticlesTarget);
    hide(this.tenMinDemoArticlesTarget);
  }

  setCtaActive(element) {
    element.classList.add(this.isActiveClass);
  }

  setCtaInactive(element) {
    element.classList.remove(this.isActiveClass);
  }
}
